module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/tandc_icon.svg";